import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/observable';
import { EnvironmentSettings } from '../models/environmentsettings.model';

@Injectable()
export class CommonService {
    environmentSettings: EnvironmentSettings;
    constructor(private _http: HttpClient) {
        this.environmentSettings = new EnvironmentSettings();
    }
    getBreadCrumbByUrl(url: string): Observable<any> {
        return this._http.get(this.environmentSettings.apiEndPoint + 'api/breadcrumb/' + url);
    }
    getSearchResultsByDescription(searchText: string): Observable<any> {
        return this._http.get(this.environmentSettings.apiEndPoint + 'api/search/' + searchText);
    }
}



// WEBPACK FOOTER //
// ./src/opc/shared/services/common.service.ts